module.exports = __webpack_public_path__ + "img/discover.d41ffed9.svg";